export const STATUS_OK = 'OK'
export const STATUS_OG = 'OG'
export const STATUS_NOK = 'NOK'

export const VT_SOURCE = 'vt'
